var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBetaStar(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 6a1 1 0 01.949.684l1.467 4.4 4.4 1.467a1 1 0 010 1.898l-4.4 1.467-1.467 4.4a1 1 0 01-1.898 0l-1.467-4.4-4.4-1.467C2.275 14.313 2 13.069 2 13.5a1 1 0 01.684-.949l4.4-1.467 1.467-4.4A1 1 0 019.5 6zm0 4.162l-.676 2.03a1 1 0 01-.633.632l-2.029.676 2.03.676a1 1 0 01.632.633l.676 2.029.676-2.03a1 1 0 01.633-.632l2.029-.676-2.03-.676a1 1 0 01-.632-.633L9.5 10.162zM17.5 2.4a.6.6 0 01.57.41l.78 2.34 2.34.78a.6.6 0 010 1.14l-2.34.78-.78 2.34a.6.6 0 01-1.14 0l-.78-2.34-2.34-.78a.6.6 0 010-1.14l2.34-.78.78-2.34a.6.6 0 01.57-.41z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBetaStar);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/iconBetaStar.35439957.svg";
export { MemoForwardRef as ReactComponent };